module.exports = __webpack_public_path__ + "static/media/main-star-icon.dead0370.svg";